/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API48014Req {
  
  /**  */
  id?: number;
  /** 业务编号 */
  bizNo?: string;
  /** 评论类型（biz_plan：商业计划书；project_plan：项目计划书） */
  commentType?: string;
  /** 评论内容 */
  comment?: string;
  /** 引用内容 */
  quote?: string;
  /** 数据模块字段 */
  dataTitle?: string;
  /** 引用内容前端样式id */
  quoteId?: string;
};



export interface API48014Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 48014 评估批注商业计划书，本接口只针对商业计划书评论

export interface IUsePostAPI48014Return {
  /** 评估批注商业计划书，本接口只针对商业计划书评论: 接口请求状态 */
  isAPI48014Loading: boolean;
  /** 评估批注商业计划书，本接口只针对商业计划书评论: 接口请求返回数据 */
  dataAPI48014: API48014Res;
  /**  评估批注商业计划书，本接口只针对商业计划书评论: 接口数据请求方法 */
  fetchAPI48014Data:  (inputs: API48014Req, config?: YWRequestConfig) => Promise<API48014Res>;
  /** 评估批注商业计划书，本接口只针对商业计划书评论: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48014 = ():IUsePostAPI48014Return => {
  let isMount = true;
  const [isAPI48014Loading, setIsAPI48014Loading] = useState(false);
  const [dataAPI48014, setDataAPI48014] = useState<API48014Res>({} as API48014Res);
  const requestUrl = `${basePath}/corp-admin/project/comment/plan4biz/create`;

  const fetchAPI48014Data = async (inputs: API48014Req, config?: YWRequestConfig): Promise<API48014Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48014Req>) || {}) as API48014Req;
    
  
    if ( isMount ) {
      setIsAPI48014Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48014Res>(`${basePath}/corp-admin/project/comment/plan4biz/create`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48014(res || {} as API48014Res);
        setIsAPI48014Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48014Loading(false);
      }
      return false as unknown as API48014Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48014Loading,
    dataAPI48014,
    fetchAPI48014Data,
    requestUrl,
  }
}

